import { observer } from "mobx-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import { LeftArrowWhite } from "src/assets/images/svg/LeftArrow";
import FailIconDisplay from "../../components/ui/FailIconDisplay";

const CameraErrorComponent = observer((props) => {
    const { children, title, header, previousPage } = props;
    const navigate = useNavigate();

    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full">
                <div>
                    <div className="text-left">
                        <Button
                            className=""
                            variant="primaryBack"
                            onClick={() => {
                                navigate(previousPage, { replace: true });
                            }}
                        >
                            <LeftArrowWhite />
                        </Button>
                    </div>
                    <div className="grid gap-[16px] mt-8">
                        <div className="text-h5 font-bold text-flow-heading">
                            <span>{title}</span>
                        </div>
                        <div className="text-body text-Gray900">
                            <span>{header}</span>
                        </div>
                    </div>
                    <div className="w-[313px] h-[313px]">
                        <div className="mt-4 relative">
                            <FailIconDisplay />
                        </div>
                    </div>
                    <div className="mt-6 grid gap-2">{children}</div>
                </div>
                <div className=""></div>
            </div>
        </div>
    );
});

export default CameraErrorComponent;
